'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GMap;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAsyncScriptLoader = require('react-async-script-loader');

var _reactAsyncScriptLoader2 = _interopRequireDefault(_reactAsyncScriptLoader);

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
* The GMap component is used to find a location.
*/


function GMap(props) {
  var apiKey = props.apiKey,
      rest = _objectWithoutProperties(props, ['apiKey']);

  var Component = (0, _reactAsyncScriptLoader2.default)('https://maps.googleapis.com/maps/api/js?key=' + apiKey)(_component2.default);
  return _react2.default.createElement(Component, rest);
}

GMap.propTypes = {
  /** The application's API key. To use the Google Maps JavaScript API,
   * you must get an API Key. See https://console.cloud.google.com/google/maps-apis/overview
   * to get an API Key. */
  apiKey: _propTypes2.default.string.isRequired,

  /** The angular distance of a place north or south of the earth's equator. */
  latitude: _propTypes2.default.number,

  /** The angular distance of a place east or west of the meridian at Greenwich */
  longitude: _propTypes2.default.number,

  /** Represent the initial resolution at which to display the map,
   * where zoom 0 corresponds to a map of the Earth fully zoomed out,
   * and larger zoom levels zoom in at a higher resolution.
   * Specify zoom level as an integer. This value defaults to 8. */
  zoom: _propTypes2.default.number,

  /** The header can include text or another component,
  * and is displayed below the map and above the markers. */
  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.object]),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2.default.object
};
GMap.defaultProps = {
  latitude: 37.8,
  longitude: -122.5,
  zoom: 8,
  header: undefined,
  children: null,
  className: undefined,
  style: undefined
};